function isError(value) {
  return value instanceof Error;
}
function isFunction(value) {
  return typeof value === "function";
}
export {
  isError,
  isFunction
};
//# sourceMappingURL=type-checking.es.js.map
